<style lang="scss" scoped>
.module2 {
  .slide-4 {
    background-image: url(../../../assets/module2/slide4/background-01.jpg);
    background-size: cover;
    background-position: center;
    padding-top: 90px;
    height: calc(100% - 90px);
    .content {
      padding-top: 50px;
    }
    .content-bendy,
    .content-bend {
      font-family: "Kookycat-FASTcaps";
      font-weight: 100;
      letter-spacing: 3px;
    }
    .content-bend {
      position: relative;
    }
    .bend-letter {
      height: 300px;
      position: absolute;
      width: 20px;
      left: 0;
      top: 0;
      transform-origin: bottom center;
      &:nth-child(1) {
        transform: rotate(3deg);
      }
      &:nth-child(2) {
        transform: rotate(8deg);
      }
      &:nth-child(3) {
        transform: rotate(13deg);
      }
      &:nth-child(4) {
        transform: rotate(19deg);
      }
      &:nth-child(5) {
        transform: rotate(25deg);
      }
      &:nth-child(6) {
        transform: rotate(31deg);
      }
      &:nth-child(7) {
        transform: rotate(35deg);
      }
      &:nth-child(8) {
        transform: rotate(41deg);
      }
    }
    .page-left {
      padding-right: 8%;
    }
    .right-content {
      margin-left: auto;
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      align-items: top;
      font-family: "Kookycat-FASTcaps";
      font-weight: 100;
    }
    .right-right-content {
      display: flex;
      flex-direction: column;
      margin-top: 17%;
      font-size: 35px;
    }
    .heading1 {
      color: #1c3965;
      font-size: 70px;
      transform: rotate(-5deg);
    }
    .heading2,
    .heading3,
    .heading4 {
      color: #fde38f;
      font-size: 50px;
      transform: rotate(-5deg);
    }
    .heading2 {
      padding-left: 40px;
    }
    .heading4 {
      padding-left: 60px;
    }
    .heading5 {
      font-size: 700px;
      line-height: 1;
    }
    .face {
      font-size: 100px;
      margin-bottom: -15px;
    }
    .last-line {
    }
    .one {
      color: #e73048;
    }
  }
}
</style>

<template>
  <div class="slide-4">
    <div class="pages">
      <div class="page page-left">
        <transition name="scale" appear>
          <h1
            class="heading1 delay-1"
            v-html="$t('module2.slide4.heading1')"
            v-show="slideIndex == 3"
          ></h1>
        </transition>
        <transition name="scale" appear>
          <div class="delay-2" v-show="slideIndex == 3">
            <h1
              class="heading2"
              v-html="$t('module2.slide4.heading2')"
              v-show="slideIndex == 3"
            ></h1>
            <h1
              class="heading3"
              v-html="$t('module2.slide4.heading3')"
              v-show="slideIndex == 3"
            ></h1>
            <h1
              class="heading4"
              v-html="$t('module2.slide4.heading4')"
              v-show="slideIndex == 3"
            ></h1>
          </div>
        </transition>

        <transition name="fadeUp" appear>
          <div class="content delay-3" v-show="slideIndex == 3">
            <p v-html="$t('module2.slide4.content1')"></p>
          </div>
        </transition>
        <transition name="fadeUp" appear>
          <div class="content delay-4" v-show="slideIndex == 3">
            <p>
              <span v-html="$t('module2.slide4.content2')"></span>&nbsp;
              <span
                class="content-bendy"
                v-html="$t('module2.slide4.contentBendy')"
              ></span>
              <span class="content-bend">
                &nbsp;
                <span class="bend-letter">d</span>
                <span class="bend-letter">r</span>
                <span class="bend-letter">o</span>
                <span class="bend-letter">o</span>
                <span class="bend-letter">p</span>
                <span class="bend-letter">i</span>
                <span class="bend-letter">n</span>
                <span class="bend-letter">g.</span>
              </span>
            </p>
          </div>
        </transition>
      </div>
      <div class="page page-right">
        <div class="right-content">
          <transition name="fadeRight" appear>
            <div class="delay-4" v-show="slideIndex == 3">
              <h1 class="heading5" v-html="$t('module2.slide4.heading5')"></h1>
            </div>
          </transition>
          <transition name="fadeRight" appear>
            <div v-show="slideIndex == 3" class="right-right-content delay-5">
              <span v-html="$t('module2.slide4.content3')"></span>
              <span v-html="$t('module2.slide4.content4')" class="face"></span>
              <span v-html="$t('module2.slide4.content5')"></span>
              <span v-html="$t('module2.slide4.content6')"></span>
              <span class="last-line">
                <span v-html="$t('module2.slide4.content7')" class="one"></span>
                &nbsp;<span v-html="$t('module2.slide4.content8')"></span>
              </span>
            </div>
          </transition>
        </div>
      </div>
    </div>

    <transition name="fadeUp" appear>
      <img
        src="@/assets/module2/slide4/frank-01.png"
        v-show="slideIndex == 3"
        class="chars delay-6"
      />
    </transition>
  </div>
</template>

<script>
export default {
  props: ["slideIndex"]
};
</script>
